<sew-video
    [src]="videoSrc"
    [caption]="caption"
    aspect-ratio="16/9"
    [consentButtonText]="labels?.CMS_MAP_CONSENT_BUTTON ?? ''"
>
    <p [innerHTML]="labels?.CMS_MAP_CONSENT_DESCRIPTION ?? ''"></p>
</sew-video>
